module.exports = __webpack_public_path__ + "static/media/TrainingVideo.da045833.mp4";